export const isNoEnd = (start: Date, end: Date): Boolean => {
  return new Date(end).getTime() - new Date(start).getTime() > 1000 * 60 * 60 * 1000;
};
